<template>
    <veui-dialog
        :open="show"
        :footless="true"
        :closable="false"
        ui="auto"
        overlay-class="service-dialog-box"
    >
        <div class="service-dialog">
            <div class="title">百度律临服务号</div>
            <div class="close-icon" @click="close('icon')">
                <veui-icon
                    name="times"
                ></veui-icon>
            </div>
            <div class="sub-title">微信扫码关注服务号并完成绑定，即可完成任务</div>
            <div class="qrcode-box">
                <img
                    class="qrcode"
                    :src="lawyerServiceQrCode"
                    alt=""
                />
            </div>
            <div class="tips">此二维码为您的专属二维码，请勿给他人使用</div>
            <veui-button
                ui="primary"
                class="btn"
                @click="close('btn')"
            >
                我知道了
            </veui-button>
        </div>
    </veui-dialog>
</template>
<script>
/**
 * @file 法律 新版本发布弹框
 */

import {Dialog, Button, Icon} from 'veui';
const URL = {
    getqrticket: '/bp/api/wechat/getqrticket'
};

export default {
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button,
        'veui-icon': Icon
    },
    computed: {
        lawyerServiceQrCode() {
            return 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + this.serviceNumberTicket;
        }
    },
    props: {
        show: {
            type: Boolean,
            defaule: false
        }
    },
    data() {
        return {
            serviceNumberTicket: ''
        };
    },
    created() {
        this.getQrTicket();
    },
    methods: {
        /**
         * 获取二维码接口
         */

        getQrTicket() {
            this.$http.get(URL.getqrticket, {
            }).then(res => {
                res = this.$normalizeResponseData(res);
                if (!res) {
                    return;
                }
                this.serviceNumberTicket = res.qr_ticket || '';
                this.$wywLog.send({
                    serverId: 17629,
                    area: 'fwh-btn',
                    action: 'show',
                    scene: this.guideType === 1 ? 1 : 0
                });
            }).catch(err => this.$normalizeResponseError(err));
        },

        close(type) {
            this.$emit('close', type);
        }
    }
};
</script>
<style lang='less' scoped>
.service-dialog-box {
    /deep/ .veui-dialog-content {
        padding-bottom: 0;
    }

    /deep/ .veui-dialog-content-head {
        padding: 0;
    }

    /deep/ .veui-dialog-content-body {
        padding: 0;

        .service-dialog {
            width: 460px;
            padding: 20px 24px 24px;

            .veui-dialog-content-head,
            .veui-dialog-content-body {
                padding: 0;
            }

            .title {
                color: #1e1f24;
                text-align: center;
                font-family: PingFang SC;
                font-weight: 500;
                font-size: 18px;
                line-height: 18px;
            }

            .sub-title {
                margin-top: 14px;
                color: #848691;
                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 14px;
                text-align: center;
            }

            .close-icon {
                position: absolute;
                cursor: pointer;
                z-index: 1;
                top: 22px;
                right: 24px;
            }

            .qrcode-box {
                margin: 24px auto 0;
                width: 149px;
                height: 149px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                border-radius: 8px;
                border: 1px solid rgba(222, 223, 224, .5);

                .qrcode {
                    width: 120px;
                    height: 120px;
                    border-radius: 8px;
                    border: 1px solid rgba(222, 223, 224, .5);
                }
            }

            .tips {
                margin-top: 14px;
                color: #848691;
                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 14px;
                text-align: center;
            }

            .btn {
                cursor: pointer;
                margin-top: 24px;
                height: 40px;
                font-size: 16px;
                color: #fff;
                line-height: 40px;
                width: 100%;
            }
        }
    }
}
</style>
